
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ReservationService } from '../reservations.service';
import { constant } from '../../../app.constants';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from '../../../core/helpers/sweet-alert-helper.service';
import { PayorEnum } from 'app/core/enums/payor.enum';
import { TripReasonTransportEnum } from 'app/core/enums/trip-reason-transport.enum';
declare var jQuery: any;

@Component({
  selector: 'app-edit-reservation',
  templateUrl: './edit-reservation.component.html',
  styleUrls: ['./edit-reservation.component.scss']
})
export class EditReservationComponent implements OnInit, OnDestroy, OnChanges {

  @Input() tripIdInput: any;
  @Output() closeNewEditReservationForm: EventEmitter < any > = new EventEmitter < any > ();
  @Input() viewBtnOpenRidersCreate = false;
  @ViewChild('legsBtn') private legsBtn: ElementRef;
  @ViewChild('parentLinkTabs') private parentLinkTabs: ElementRef;
  @Output() reloadGrids: EventEmitter < any > = new EventEmitter < any > ();
  @Output() emitterOpenAppRidersCreate = new EventEmitter < any > ();
  protected isOpenAppRidersCreate = false;
  protected fullname: any;
  protected reservations: any;
  protected reservationsLock = [];
  protected isLoading = false;
  protected longitudArray = 0;
  protected href = '';
  protected tab: any;
  public mask_time = constant.MASK_TIMES;
  protected tripEditing: any = {
    tripid: 0,
    isEditing: false
  };
  private observables: Subscription[] = [];
  messageModifiersDuplicate: string;

  constructor(
    protected service: ReservationService,
    protected render: Renderer,
    protected element: ElementRef,
    private sweetAlertHelper: SweetAlertHelper,
  ) {

  }

  ngOnInit() {
    // this.loadTripsFromReservations(this.tripIdInput)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tripIdInput']) {
      this.loadTripsFromReservations(this.tripIdInput.reservationid);
      this.tab = this.tripIdInput.tripid;
    }
  }

  reloadTrips(tripid) {
    // alert(this.tripIdInput.tripid);
    this.tripIdInput.tripid = tripid;
    this.tab = tripid;
    this.loadTripsFromReservations(this.tripIdInput.reservationid);
  }

  loadTripsFromReservations(reservationid) {
    this.isLoading = true;
    this.observables.push(
    this.service.getLegsByReservation(reservationid).subscribe(
      data => {
        this.isLoading = false;
        this.reservations = data;
        this.updateLongitud();
        this.fullname = this.reservations[0].rider.fullname;
        this.verifyModifiers(data);
      }
    ));
  }

  ngOnDestroy() {
    const me = this;
    this.reservationsLock.map(function (item) {
      me.service.putEnableTripForm(item).subscribe(
        data => {

        },
        error => {

        }
      );
    });
    if (this.observables && this.observables.length) {
      this.observables.forEach((subscription) => {
        if (subscription) {
          subscription.unsubscribe();
        }
      });
    }
  }

  processingLockStatus(tripLockStatus) {
    if (tripLockStatus.lock) {
      this.reservationsLock.push(tripLockStatus.tripid);
    } else {
      this.reservationsLock.forEach((item, index) => {
        if (item === tripLockStatus.tripid) {
          this.reservationsLock.splice(index, 1);
        }
      });
    }
  }

  private onClickTab(event, item) {
    if (this.tripEditing.tripid !== item.tripid && this.tripEditing.isEditing) {
      this.tripIdInput.tripid = this.tripEditing.tripid;
    } else {
      this.href = '#leg-' + item.leg;
    }
  }

  protected reloadParentGrids() {
    this.reloadGrids.emit(false);
  }

  protected onOpenAppRidersCreate(isOpen: boolean) {
    this.isOpenAppRidersCreate = isOpen;
    this.emitterOpenAppRidersCreate.emit(isOpen);
  }

  protected onReloadTripData(newTrip) {
    if(newTrip) {
      if (this.reservations[this.reservations.length - 1].tripid === newTrip.tripid) {
        this.reservations[this.reservations.length - 1] = newTrip;
      }
    }
  }

  private removeActiveFromLegTabs() {
    jQuery('.parentulclass li a').each(() => {
      jQuery('.parentulclass li a').removeClass('active');
    });
    jQuery('.parentContentCls .fade').each(() => {
      jQuery('.parentContentCls .contentEditReservationCls').removeClass('active in');
    });
  }

  private updateLongitud() {
    this.longitudArray = this.reservations.length;
  }

  addNewLeg(): void {
    const firstRow = this.reservations.at(0);

    const simplyListObj: PayorEnum[] = [
      PayorEnum.SimplyMCR,
      PayorEnum.SimplyClear,
      PayorEnum.SimplyMMA,
      PayorEnum.SimplyFHK
    ];

    const tripReasonListObj: TripReasonTransportEnum[] = [
      TripReasonTransportEnum.FccNonMedical,
      TripReasonTransportEnum.NonMedicalMMA,
      TripReasonTransportEnum.NonMedicalMCR,
      TripReasonTransportEnum.NonMedicalCha
    ];

    if (simplyListObj.includes(firstRow.payorid) ) {
      const numLegsWithNonMedicals = this.reservations
      .filter((leg: any) => tripReasonListObj.includes(leg.tripreasontransportid)).length;

      if (numLegsWithNonMedicals >= 1) {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Warning!',
          text: 'Multi-trip is not allowed for Non medical trips',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
        });
      } else {
        this.legInitStatus();
      }
    } else {
      this.legInitStatus();
    }
  }

  legInitStatus(): void  {
    // this.render.setElementClass(this.legsBtn,'active', false);
    this.removeActiveFromLegTabs();
    const newLeg = JSON.parse(JSON.stringify(this.reservations[this.reservations.length - 1]));
    newLeg.triplocationpickup = newLeg.triplocationdropoff;
    newLeg.triplocationdropoff = this.locationBlank();
    newLeg.leg = this.getNextLetter();
    newLeg.tripid = 0;
    newLeg.tripstatusid = 1;
    newLeg.consecutive = 0;
    newLeg.appointment = '';
    newLeg.pickup = '';
    newLeg.activationtime = '';
    newLeg.activationtimeformatted = '';
    newLeg.actualpickup = '';
    newLeg.actualpickupformatted = '';
    newLeg.actualdropoff = '';
    newLeg.actualdropoffformatted = '';
    newLeg.noshowtime = '';
    newLeg.waitingtime = '';
    newLeg.iswillcall = false;
    newLeg.isreturntrip = false;
    newLeg.callreceived = this.getTodayDate();
    newLeg.tripreasontransportid = null;
    newLeg.totalamount = null;
    newLeg.driverid = null;
    newLeg.vehicleid = null;
    newLeg.driver = null;
    newLeg.vehicle = null;
    newLeg.serviceproviderid = null;
    newLeg.serviceprovidername = null;
    this.service.getGoogleOdrdGuid().subscribe((data) => {
      newLeg.googleordrid = data;
    });
    delete newLeg.triplocationpickup.modifier;
    delete newLeg.triplocationdropoff.modifier;
    delete newLeg.tripstatus;
    this.tripIdInput.tripid = 0;
    this.reservations.push(newLeg);
    this.tab = 0;
    this.updateLongitud();
  }

  private getTodayDate() {
    const date = new Date();
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    const hours = date.getHours();
    const mins = date.getMinutes();

    return [date.getFullYear(),
      (mm > 9 ? '' : '0') + mm,
      (dd > 9 ? '' : '0') + dd
    ].join('-') + ' ' + [(hours > 9 ? '' : '0') + hours, (mins > 9 ? '' : '0') + mins].join(':');
  }

  removeNewLeg() {
    this.removeActiveFromLegTabs();
    this.tripIdInput.tripid = 0;
    this.reservations.pop();
    this.tripIdInput.tripid = this.reservations[this.reservations.length - 1].tripid;
    this.tab = this.tripIdInput.tripid;
  }

  private locationBlank() {
    return {
      latitude: 0,
      longitude: 0,
      location: '',
      streetaddress: '',
      city: '',
      state: '',
      zip: '',
      modifierid: 0
    };
  }

  private getNextLetter(): string {
    const code = 65 + this.reservations.length;
    return String.fromCharCode(code);
  }
  protected closeNewEditReservationBtn() {
    this.closeNewEditReservationForm.emit(false);
  }

    /**
   * @description Verificar diplicate modifier
   */
  verifyModifiers(trips: any) {

    let duplicates = '';

    trips.forEach(element => {
      if (element.tripstatusid !== 7 && element.tripstatusid !== 6) {
        if (element.triplocationpickup && element.triplocationdropoff) {
          if (element.triplocationpickup.modifierid && element.triplocationdropoff.modifierid) {
            const combination = `${element.triplocationpickup.modifierid}${element.triplocationdropoff.modifierid}`;
            trips.forEach(elem => {
              if (element.leg !== elem.leg) {
                if (elem.tripstatusid !== 7 && elem.tripstatusid !== 6) {
                  if (elem.triplocationpickup && elem.triplocationdropoff) {
                    if (elem.triplocationpickup.modifierid && elem.triplocationdropoff.modifierid) {
                      if (
                        combination
                        ===
                        `${elem.triplocationpickup.modifierid}${elem.triplocationdropoff.modifierid}`
                      ) {
                        duplicates = `<p>This modifiers combination duplicate in leg ${element.leg} and leg ${elem.leg}</p>`;
                      }
                    }
                  }
                }
              }
            });
          }
        }
      }
    });

    this.messageModifiersDuplicate = duplicates;

    if (duplicates) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Combination Modifiers Duplicate',
        html: duplicates,
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Accept',
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-reservation.component.ts